/*
 * @Author: xuchangbin changbin.xu@ctg.cn
 * @Date: 2023-08-09 15:00:29
 * @LastEditors: xuchangbin changbin.xu@ctg.cn
 * @LastEditTime: 2023-08-16 16:34:59
 * @FilePath: /customer-h5/src/service/api/pay.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { post } from './index'

/**
 * 以小程序登录 code（wx.login）换取第三方用户信息
 * @param {Object} params
 * @param {string} params.jsCode - 小程序登录 code
 * @returns {Promise<{loginInfoId: string}>} loginInfoId - 第三方登录信息ID
 */
export function getThirdUserInfo(params) {
  return post('/pay/getThirdUserInfo', params)
}

// 云闪付支付
export function ysfPay(params) {
  return post('/pay/ysf-pay', params)
}
// 翼支付
export function bestPay(params) {
  return post('/pay/bestpay-pay-app', params)
}
export function bestPayC2b(params) {
  return post('/pay/bestpay-pay-order-c2b', params)
}
// 中旅通支付
export function ctsPay(params) {
  return post('/pay/cts-pay', params)
}
// 中旅收银台V1版本jsapi支付接口
export function ctgPayWithJsapi(params) {
  return post('/ctg/v1/jsapi/pay', params)
}
//收银台 详情接口
// export function ctgPaymentReceiptinfo(params) {
//   return post('/ctg/v1/jsapi/pay/receiptinfo', params)
// }
// 收银台 获取批量订单详情
export function ctgPaymentBatchReceiptInfo(params) {
  return post('/ctg/v1/jsapi/batchpay/receiptinfo', params)
}
//收银台 支付结果查询
// export function getCtgPaymentResult(params) {
//   return post('/ctg/v1/jsapi/pay/query', params)
// }
// 收银台 获取批量订单的支付结果
export function getCtgPaymentBatchResult(params) {
  return post('/ctg/v1/jsapi/batchpay/query', params)
}
export function sendConfirmLog(params) {
  return post('/pay/cashier/confirm/log', params)
}
